import axios from 'axios'
import {Blog} from 'types/blogs'

export const wpBaseURL = 'https://aditya065e84dbb54.wpcomstaging.com/wp-json/wp/v2'

const extractSlugFromUrl = (url: string) => {
  if (!url) return ''
  const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url
  return cleanUrl.split('/').pop()
}

const processSearchResults = (results: any) => {
  return results.map((item: any) => {
    if (item.slug) return item
    const slug = extractSlugFromUrl(item.url)
    return {
      ...item,
      slug: slug,
    }
  })
}

export const getWordPressBlogs = async (page_number = 1, query = '') => {
  try {
    let res = await axios.get(
      `${wpBaseURL}/posts?page=${page_number}&per_page=15${query ? query : ''}&_embed`,
    )
    return {
      blogs: res.data,
      page_number: page_number,
      total_blog: res.headers['x-wp-total'],
      total_page: res.headers['x-wp-totalpages'],
    }
  } catch (error) {
    console.error({error})
    return {blogs: [], page_number: 1, total_blog: 0, total_page: 0}
  }
}

export const getWordPressBlogsByCategory = async (categoryId: string, page_number = 1) => {
  try {
    let res = await axios.get(
      `${wpBaseURL}/posts?page=${page_number}&per_page=15&categories=${categoryId}&_embed`,
    )
    return {
      blogs: res.data,
      page_number: page_number,
      total_blog: res.headers['x-wp-total'],
      total_page: res.headers['x-wp-totalpages'],
    }
  } catch (error) {
    console.error({error})
    return {blogs: [], page_number: 1, total_blog: 0, total_page: 0}
  }
}

export const getWordPressSearchedBlogs = async (searchText: string, page_number = 1) => {
  try {
    let res = await axios.get(
      `${wpBaseURL}/search?page=${page_number}&per_page=15&search=${searchText}&_embed`,
    )
    const processedResults = processSearchResults(res.data)
    return {
      blogs: processedResults,
      page_number: page_number,
      total_blog: res.headers['x-wp-total'],
      total_page: res.headers['x-wp-totalpages'],
    }
  } catch (error) {
    console.error({error})
    return {blogs: [], page_number: 1, total_blog: 0, total_page: 0}
  }
}

export const getWordPressCategories = async () => {
  try {
    let res = await axios.get(`${wpBaseURL}/categories`)
    return res.data
  } catch (error) {
    console.error({error})
    return []
  }
}

export const getWordPressTags = async () => {
  try {
    let res = await axios.get(`${wpBaseURL}/tags?per_page=100`)
    return res.data
  } catch (error) {
    console.error({error})
    return []
  }
}

export const getPostDetails = async (slug: string) => {
  try {
    let res = await axios.get(`${wpBaseURL}/posts?slug=${slug}&_embed`, {
      timeout: 10000,
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Origin': 'https://www.zenadmin.ai',
        'Referer': 'https://www.zenadmin.ai/',
        'User-Agent': 'Mozilla/5.0 (compatible; NextJS SSR)'
      }
    });
    return res.data[0];
  } catch (error) {
    console.error(`Error fetching post details for ${slug}:`, error);
    if (axios.isAxiosError(error)) {
      console.error('Status:', error.response?.status);
      console.error('Response data:', error.response?.data);
      console.error('Request URL:', error.config?.url);
    }
    return null;
  }
}

export const getLatestThreeBlogs = async ({
  page_number = 1,
}: {
  page_number?: number
}): Promise<Blog[] | undefined> => {
  try {
    let res = await axios.get(`${wpBaseURL}/posts?page=${page_number}&per_page=4&_embed`)
    return res.data
  } catch (error) {
    console.error({error})
    return []
  }
}
